/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaVectorScore model module.
 * @module model/AqaVectorScore
 * @version v0
 */
export default class AqaVectorScore {
  /**
   * Constructs a new <code>AqaVectorScore</code>.
   * @alias module:model/AqaVectorScore
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorScore</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorScore} obj Optional instance to populate.
   * @return {module:model/AqaVectorScore} The populated <code>AqaVectorScore</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorScore();
      if (data.hasOwnProperty('rag'))
        obj.rag = ApiClient.convertToType(data['rag'], 'String');
      if (data.hasOwnProperty('populationRag'))
        obj.populationRag = ApiClient.convertToType(data['populationRag'], 'String');
      if (data.hasOwnProperty('uniquenessRag'))
        obj.uniquenessRag = ApiClient.convertToType(data['uniquenessRag'], 'String');
      if (data.hasOwnProperty('numberRag'))
        obj.numberRag = ApiClient.convertToType(data['numberRag'], 'String');
      if (data.hasOwnProperty('dateRag'))
        obj.dateRag = ApiClient.convertToType(data['dateRag'], 'String');
      if (data.hasOwnProperty('stringRag'))
        obj.stringRag = ApiClient.convertToType(data['stringRag'], 'String');
      if (data.hasOwnProperty('typeRag'))
        obj.typeRag = ApiClient.convertToType(data['typeRag'], 'String');
      if (data.hasOwnProperty('nativeErrorRag'))
        obj.nativeErrorRag = ApiClient.convertToType(data['nativeErrorRag'], 'String');
      if (data.hasOwnProperty('numberOfPopulationQualityDefinitions'))
        obj.numberOfPopulationQualityDefinitions = ApiClient.convertToType(data['numberOfPopulationQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessQualityDefinitions'))
        obj.numberOfUniquenessQualityDefinitions = ApiClient.convertToType(data['numberOfUniquenessQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNumberQualityDefinitions'))
        obj.numberOfNumberQualityDefinitions = ApiClient.convertToType(data['numberOfNumberQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfDateQualityDefinitions'))
        obj.numberOfDateQualityDefinitions = ApiClient.convertToType(data['numberOfDateQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfStringQualityDefinitions'))
        obj.numberOfStringQualityDefinitions = ApiClient.convertToType(data['numberOfStringQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfTypeQualityDefinitions'))
        obj.numberOfTypeQualityDefinitions = ApiClient.convertToType(data['numberOfTypeQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorQualityDefinitions'))
        obj.numberOfNativeErrorQualityDefinitions = ApiClient.convertToType(data['numberOfNativeErrorQualityDefinitions'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationReds'))
        obj.numberOfPopulationReds = ApiClient.convertToType(data['numberOfPopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfPopulationAmbers'))
        obj.numberOfPopulationAmbers = ApiClient.convertToType(data['numberOfPopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessReds'))
        obj.numberOfUniquenessReds = ApiClient.convertToType(data['numberOfUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfUniquenessAmbers'))
        obj.numberOfUniquenessAmbers = ApiClient.convertToType(data['numberOfUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNumberReds'))
        obj.numberOfNumberReds = ApiClient.convertToType(data['numberOfNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfNumberAmbers'))
        obj.numberOfNumberAmbers = ApiClient.convertToType(data['numberOfNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDateReds'))
        obj.numberOfDateReds = ApiClient.convertToType(data['numberOfDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfDateAmbers'))
        obj.numberOfDateAmbers = ApiClient.convertToType(data['numberOfDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfStringReds'))
        obj.numberOfStringReds = ApiClient.convertToType(data['numberOfStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfStringAmbers'))
        obj.numberOfStringAmbers = ApiClient.convertToType(data['numberOfStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfTypeReds'))
        obj.numberOfTypeReds = ApiClient.convertToType(data['numberOfTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfTypeAmbers'))
        obj.numberOfTypeAmbers = ApiClient.convertToType(data['numberOfTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorReds'))
        obj.numberOfNativeErrorReds = ApiClient.convertToType(data['numberOfNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfNativeErrorAmbers'))
        obj.numberOfNativeErrorAmbers = ApiClient.convertToType(data['numberOfNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationReds'))
        obj.numberOfDiscretePopulationReds = ApiClient.convertToType(data['numberOfDiscretePopulationReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscretePopulationAmbers'))
        obj.numberOfDiscretePopulationAmbers = ApiClient.convertToType(data['numberOfDiscretePopulationAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessReds'))
        obj.numberOfDiscreteUniquenessReds = ApiClient.convertToType(data['numberOfDiscreteUniquenessReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteUniquenessAmbers'))
        obj.numberOfDiscreteUniquenessAmbers = ApiClient.convertToType(data['numberOfDiscreteUniquenessAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberReds'))
        obj.numberOfDiscreteNumberReds = ApiClient.convertToType(data['numberOfDiscreteNumberReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberAmbers'))
        obj.numberOfDiscreteNumberAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatAmbers'))
        obj.numberOfDiscreteNumberFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberFormatReds'))
        obj.numberOfDiscreteNumberFormatReds = ApiClient.convertToType(data['numberOfDiscreteNumberFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryAmbers'))
        obj.numberOfDiscreteNumberBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNumberBoundaryReds'))
        obj.numberOfDiscreteNumberBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteNumberBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateReds'))
        obj.numberOfDiscreteDateReds = ApiClient.convertToType(data['numberOfDiscreteDateReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateAmbers'))
        obj.numberOfDiscreteDateAmbers = ApiClient.convertToType(data['numberOfDiscreteDateAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatAmbers'))
        obj.numberOfDiscreteDateFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteDateFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateFormatReds'))
        obj.numberOfDiscreteDateFormatReds = ApiClient.convertToType(data['numberOfDiscreteDateFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryAmbers'))
        obj.numberOfDiscreteDateBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteDateBoundaryReds'))
        obj.numberOfDiscreteDateBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteDateBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringReds'))
        obj.numberOfDiscreteStringReds = ApiClient.convertToType(data['numberOfDiscreteStringReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAmbers'))
        obj.numberOfDiscreteStringAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedAmbers'))
        obj.numberOfDiscreteStringAllowedAmbers = ApiClient.convertToType(data['numberOfDiscreteStringAllowedAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringAllowedReds'))
        obj.numberOfDiscreteStringAllowedReds = ApiClient.convertToType(data['numberOfDiscreteStringAllowedReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryAmbers'))
        obj.numberOfDiscreteStringBoundaryAmbers = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringBoundaryReds'))
        obj.numberOfDiscreteStringBoundaryReds = ApiClient.convertToType(data['numberOfDiscreteStringBoundaryReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatAmbers'))
        obj.numberOfDiscreteStringFormatAmbers = ApiClient.convertToType(data['numberOfDiscreteStringFormatAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteStringFormatReds'))
        obj.numberOfDiscreteStringFormatReds = ApiClient.convertToType(data['numberOfDiscreteStringFormatReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeReds'))
        obj.numberOfDiscreteTypeReds = ApiClient.convertToType(data['numberOfDiscreteTypeReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteTypeAmbers'))
        obj.numberOfDiscreteTypeAmbers = ApiClient.convertToType(data['numberOfDiscreteTypeAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorReds'))
        obj.numberOfDiscreteNativeErrorReds = ApiClient.convertToType(data['numberOfDiscreteNativeErrorReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteNativeErrorAmbers'))
        obj.numberOfDiscreteNativeErrorAmbers = ApiClient.convertToType(data['numberOfDiscreteNativeErrorAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfReds'))
        obj.numberOfReds = ApiClient.convertToType(data['numberOfReds'], 'Number');
      if (data.hasOwnProperty('numberOfAmbers'))
        obj.numberOfAmbers = ApiClient.convertToType(data['numberOfAmbers'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteReds'))
        obj.numberOfDiscreteReds = ApiClient.convertToType(data['numberOfDiscreteReds'], 'Number');
      if (data.hasOwnProperty('numberOfDiscreteAmbers'))
        obj.numberOfDiscreteAmbers = ApiClient.convertToType(data['numberOfDiscreteAmbers'], 'Number');
      if (data.hasOwnProperty('anyRed'))
        obj.anyRed = ApiClient.convertToType(data['anyRed'], 'Number');
      if (data.hasOwnProperty('anyAmber'))
        obj.anyAmber = ApiClient.convertToType(data['anyAmber'], 'Number');
      if (data.hasOwnProperty('anyGreen'))
        obj.anyGreen = ApiClient.convertToType(data['anyGreen'], 'Number');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>rag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.RagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.RagEnum} rag
 */
AqaVectorScore.prototype.rag = undefined;

/**
 * Allowed values for the <code>populationRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.PopulationRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.PopulationRagEnum} populationRag
 */
AqaVectorScore.prototype.populationRag = undefined;

/**
 * Allowed values for the <code>uniquenessRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.UniquenessRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.UniquenessRagEnum} uniquenessRag
 */
AqaVectorScore.prototype.uniquenessRag = undefined;

/**
 * Allowed values for the <code>numberRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.NumberRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.NumberRagEnum} numberRag
 */
AqaVectorScore.prototype.numberRag = undefined;

/**
 * Allowed values for the <code>dateRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.DateRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.DateRagEnum} dateRag
 */
AqaVectorScore.prototype.dateRag = undefined;

/**
 * Allowed values for the <code>stringRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.StringRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.StringRagEnum} stringRag
 */
AqaVectorScore.prototype.stringRag = undefined;

/**
 * Allowed values for the <code>typeRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.TypeRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.TypeRagEnum} typeRag
 */
AqaVectorScore.prototype.typeRag = undefined;

/**
 * Allowed values for the <code>nativeErrorRag</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorScore.NativeErrorRagEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorScore.NativeErrorRagEnum} nativeErrorRag
 */
AqaVectorScore.prototype.nativeErrorRag = undefined;

/**
 * @member {Number} numberOfPopulationQualityDefinitions
 */
AqaVectorScore.prototype.numberOfPopulationQualityDefinitions = undefined;

/**
 * @member {Number} numberOfUniquenessQualityDefinitions
 */
AqaVectorScore.prototype.numberOfUniquenessQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNumberQualityDefinitions
 */
AqaVectorScore.prototype.numberOfNumberQualityDefinitions = undefined;

/**
 * @member {Number} numberOfDateQualityDefinitions
 */
AqaVectorScore.prototype.numberOfDateQualityDefinitions = undefined;

/**
 * @member {Number} numberOfStringQualityDefinitions
 */
AqaVectorScore.prototype.numberOfStringQualityDefinitions = undefined;

/**
 * @member {Number} numberOfTypeQualityDefinitions
 */
AqaVectorScore.prototype.numberOfTypeQualityDefinitions = undefined;

/**
 * @member {Number} numberOfNativeErrorQualityDefinitions
 */
AqaVectorScore.prototype.numberOfNativeErrorQualityDefinitions = undefined;

/**
 * @member {Number} numberOfPopulationReds
 */
AqaVectorScore.prototype.numberOfPopulationReds = undefined;

/**
 * @member {Number} numberOfPopulationAmbers
 */
AqaVectorScore.prototype.numberOfPopulationAmbers = undefined;

/**
 * @member {Number} numberOfUniquenessReds
 */
AqaVectorScore.prototype.numberOfUniquenessReds = undefined;

/**
 * @member {Number} numberOfUniquenessAmbers
 */
AqaVectorScore.prototype.numberOfUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfNumberReds
 */
AqaVectorScore.prototype.numberOfNumberReds = undefined;

/**
 * @member {Number} numberOfNumberAmbers
 */
AqaVectorScore.prototype.numberOfNumberAmbers = undefined;

/**
 * @member {Number} numberOfDateReds
 */
AqaVectorScore.prototype.numberOfDateReds = undefined;

/**
 * @member {Number} numberOfDateAmbers
 */
AqaVectorScore.prototype.numberOfDateAmbers = undefined;

/**
 * @member {Number} numberOfStringReds
 */
AqaVectorScore.prototype.numberOfStringReds = undefined;

/**
 * @member {Number} numberOfStringAmbers
 */
AqaVectorScore.prototype.numberOfStringAmbers = undefined;

/**
 * @member {Number} numberOfTypeReds
 */
AqaVectorScore.prototype.numberOfTypeReds = undefined;

/**
 * @member {Number} numberOfTypeAmbers
 */
AqaVectorScore.prototype.numberOfTypeAmbers = undefined;

/**
 * @member {Number} numberOfNativeErrorReds
 */
AqaVectorScore.prototype.numberOfNativeErrorReds = undefined;

/**
 * @member {Number} numberOfNativeErrorAmbers
 */
AqaVectorScore.prototype.numberOfNativeErrorAmbers = undefined;

/**
 * @member {Number} numberOfDiscretePopulationReds
 */
AqaVectorScore.prototype.numberOfDiscretePopulationReds = undefined;

/**
 * @member {Number} numberOfDiscretePopulationAmbers
 */
AqaVectorScore.prototype.numberOfDiscretePopulationAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessReds
 */
AqaVectorScore.prototype.numberOfDiscreteUniquenessReds = undefined;

/**
 * @member {Number} numberOfDiscreteUniquenessAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteUniquenessAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberReds
 */
AqaVectorScore.prototype.numberOfDiscreteNumberReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteNumberAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteNumberFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberFormatReds
 */
AqaVectorScore.prototype.numberOfDiscreteNumberFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteNumberBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNumberBoundaryReds
 */
AqaVectorScore.prototype.numberOfDiscreteNumberBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateReds
 */
AqaVectorScore.prototype.numberOfDiscreteDateReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteDateAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteDateFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateFormatReds
 */
AqaVectorScore.prototype.numberOfDiscreteDateFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteDateBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteDateBoundaryReds
 */
AqaVectorScore.prototype.numberOfDiscreteDateBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringReds
 */
AqaVectorScore.prototype.numberOfDiscreteStringReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteStringAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteStringAllowedAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringAllowedReds
 */
AqaVectorScore.prototype.numberOfDiscreteStringAllowedReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteStringBoundaryAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringBoundaryReds
 */
AqaVectorScore.prototype.numberOfDiscreteStringBoundaryReds = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteStringFormatAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteStringFormatReds
 */
AqaVectorScore.prototype.numberOfDiscreteStringFormatReds = undefined;

/**
 * @member {Number} numberOfDiscreteTypeReds
 */
AqaVectorScore.prototype.numberOfDiscreteTypeReds = undefined;

/**
 * @member {Number} numberOfDiscreteTypeAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteTypeAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorReds
 */
AqaVectorScore.prototype.numberOfDiscreteNativeErrorReds = undefined;

/**
 * @member {Number} numberOfDiscreteNativeErrorAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteNativeErrorAmbers = undefined;

/**
 * @member {Number} numberOfReds
 */
AqaVectorScore.prototype.numberOfReds = undefined;

/**
 * @member {Number} numberOfAmbers
 */
AqaVectorScore.prototype.numberOfAmbers = undefined;

/**
 * @member {Number} numberOfDiscreteReds
 */
AqaVectorScore.prototype.numberOfDiscreteReds = undefined;

/**
 * @member {Number} numberOfDiscreteAmbers
 */
AqaVectorScore.prototype.numberOfDiscreteAmbers = undefined;

/**
 * @member {Number} anyRed
 */
AqaVectorScore.prototype.anyRed = undefined;

/**
 * @member {Number} anyAmber
 */
AqaVectorScore.prototype.anyAmber = undefined;

/**
 * @member {Number} anyGreen
 */
AqaVectorScore.prototype.anyGreen = undefined;

/**
 * @member {Number} timestamp
 */
AqaVectorScore.prototype.timestamp = undefined;

